






































































































































































































/** @format */

import { Vue, Component, Watch, Prop, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { cloneDeep } from 'lodash';
import { trim } from '@root/utils/validators';
import Utils from '@root/utils/common';
// axios请求
import { addOrEditArea, queryArea } from '@/api/parking-lot-management/index';
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';

// 导入字典
import {
  dictOperationTypeMap,
  dictTypeInMap,
  dictPropertyMap,
  dictAllowableChannelTypeMap,
  dictAlonePayMap,
  dictfeiPayMap
} from '@/types/parking-lot-management/dictionaries';

// form表单项定义
export interface IForm {
  areaName: string;
  areaCode: string;
  parkId: string;
  parkName: string;
  areaId: string; //区域名称
  operationType: string; //运营类型  01：开发商委托 02：业委会委托 03：小业主委托 04：自有停车场
  typeIn: string; //车位录入方式  01：手动录入 02：根据车位资源自动计算
  propertyNum: string; //产权车位数量
  // monthNum: string //月卡车位数量
  tempNum: string; //临停车位数量
  isZeroAllowedEnter: string; //满位是否允许进入 00：不允许 01：允许
  // alonePay: string //是否需要独立计费  00:不需要  01:需要
  unauthorizedEnter: string; //非授权类型车辆是否禁入 00：是 01：否
  monthNum: string; //出租车位数
}

@Component({
  components: { ParkingLotSearch }
})
export default class AddEditArea extends Vue {
  path = '/smart-parking/parking-lot-management/area-list/';

  @Prop({ default: () => {} })
  dataForm!: any;

  @Prop()
  parkId!: string;

  @Prop({ type: Boolean, default: false })
  isParkDisabled!: boolean;

  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  areaId = '';
  // 表单
  form: any = null;
  validatorsTrim = trim;

  // 运营类型选项
  @Getter('dictionaries/areaOperationType')
  areaOperationTypeMap?: any;
  get operationTypeOptions(): any[] {
    return Utils.toLabelVal(this.areaOperationTypeMap);
  }
  // operationTypeOptions: IOption[] = Utils.toLabelVal(dictOperationTypeMap)
  // 车位录入方式选项
  // @Getter('dictionaries/areaTypeIn')
  // areaTypeInMap?:object
  // get typeInOptions():any[] {
  //   return Utils.toLabelVal(this.areaTypeInMap)
  // }
  propertyOptions: IOption[] = Utils.toLabelVal(dictPropertyMap);
  typeInOptions: IOption[] = Utils.toLabelVal(dictTypeInMap);
  // 满位是否允许进入
  allowableChannelTypeOptions: IOption[] = Utils.toLabelVal(dictAllowableChannelTypeMap);
  // 是否独立计费
  // alonePayOptions: IOption[] = Utils.toLabelVal(dictAlonePayMap)
  // 非授权类型车辆是否禁入
  unauthorizedOptions: IOption[] = Utils.toLabelVal(dictfeiPayMap);
  //隐藏运营类型
  hide: boolean = false;
  spining: boolean = false;
  // 监听parkID车场信息步骤二可以回显parkId
  @Watch('parkId')
  parkIdChanged(val: boolean) {
    this.init();
  }
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }
  @Watch('dataForm', { deep: true })
  dataChanged(val: any) {
    this.init();
    // this.parkId = val.parkId
  }

  // 是否是禁用
  get isParkdisabledFlag() {
    return this.isParkDisabled;
  }
  // get getSetParkId() {
  //   if (this.isParkdisabledFlag) {
  //     return { parkId: this.parkId }
  //   }
  // }
  // 生命周期初始化
  created() {
    this.areaId = this.$route.params.areaId;
    this.init();
  }

  // 初始化form表单
  init() {
    if (this.isEdit && this.dataForm) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const {
            areaId,
            parkName,
            areaName,
            areaCode,
            operationType,
            property,
            parkId,
            typeIn,
            propertyNum,
            tempNum,
            monthNum,
            isZeroAllowedEnter,
            unauthorizedEnter
          } = this.dataForm;
          return {
            areaId: this.$form.createFormField({
              value: areaId
            }),
            parkName: this.$form.createFormField({
              value: parkName
            }),
            areaName: this.$form.createFormField({
              value: areaName
            }),
            areaCode: this.$form.createFormField({
              value: areaCode
            }),
            // operationType: this.$form.createFormField({
            //   value: operationType,
            // }),
            parkId: this.$form.createFormField({
              value: parkId
            }),
            property: this.$form.createFormField({
              value: property
            }),
            typeIn: this.$form.createFormField({
              value: typeIn
            }),
            propertyNum: this.$form.createFormField({
              value: propertyNum
            }),
            tempNum: this.$form.createFormField({
              value: tempNum
            }),
            monthNum: this.$form.createFormField({
              value: monthNum
            }),
            isZeroAllowedEnter: this.$form.createFormField({
              value: isZeroAllowedEnter
            }),
            unauthorizedEnter: this.$form.createFormField({
              value: unauthorizedEnter
            })
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            typeIn: this.$form.createFormField({
              value: '01'
            }),
            // 新增车场步骤进来，parkId自动带入表单
            parkId: this.$form.createFormField({
              value: this.isParkdisabledFlag ? this.parkId : ''
            })
          };
        }
      });
    }
  }

  // 提交监听处理
  async handleSubmit(e: any) {
    // console.log(e)
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        // this.onAddOrEdit(values)
        if (this.spining) return;
        this.spining = true;
        // 判断是否要是禁用状态，禁用状态手动加上parkId
        let park;
        if (this.isParkdisabledFlag) {
          park = { parkId: this.parkId };
        } else {
          park = {};
        }
        this.onAddOrEdit({ ...values, ...park });
      }
    });
  }
  // 提交请求发送添加
  // async onAdd(values: IForm) {
  //   // console.log(this.parkId, values)
  //   // console.log({
  //   //   ...values,
  //   //   ...(this.parkId ? { parkId: this.parkId } : {}),
  //   // })
  //   // let park
  //   // if (this.isParkdisabledFlag) {
  //   //   park = { parkId: this.parkId }
  //   // } else {
  //   //   park = {}
  //   // }
  //   try {
  //     const { data, status, msg, code } = await addOrEditArea({
  //       ...values,
  //       // ...(this.parkId ? { parkId: this.parkId } : {}),
  //     })
  //     console.log(data)
  //     if (status == '9999') {
  //       // 获取车场名称
  //       this.$message.success('新增成功')
  //       this.areaId = data
  //       const res = await queryArea({ areaId: this.areaId })
  //       console.log(res)

  //       // this.$emit('ok', { ...values, areaId: data, parkName: res.data.parkName })
  //       this.$emit('ok', { areaId: data, ...res.data })
  //       this.form.resetFields()
  //     } else {
  //       this.$message.error(msg)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     this.$message.error(e.msg)
  //   }
  // }
  // // 编辑
  // async onEdit(values: IForm) {
  //   // console.log(this.dataForm)
  //   console.log(values)
  //   try {
  //     const res = await addOrEditArea({
  //       ...values,
  //       ...(this.dataForm && this.dataForm.areaId ? { areaId: this.dataForm.areaId } : { areaId: this.areaId }),
  //     })
  //     const { data } = await queryArea({ areaId: this.areaId })
  //     console.log(res)
  //     this.$message.success('编辑成功')
  //     this.$emit('ok', {
  //       ...values,
  //       ...data,
  //       // ...(this.dataForm && this.dataForm.areaId ? { areaId: this.dataForm.areaId } : { areaId: this.areaId }),
  //     })
  //     this.form.resetFields()
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }
  // 添加和编辑
  async onAddOrEdit(values: IForm) {
    // TIP: 和后端沟通接口返回ID给前端
    let original;
    if (this.isEdit) {
      original = {
        originalParkId: this.dataForm.parkId || '',
        originalPropertyNum: this.dataForm.propertyNum || 0,
        originalMonthNum: this.dataForm.monthNum || 0,
        originalTempNum: this.dataForm.tempNum || 0
      };
    }

    try {
      const params = values.typeIn == '02' ? { ...values, tempNum: 0, propertyNum: 0, monthNum: 0 } : { ...values };
      const res = await addOrEditArea({
        ...params,
        ...(this.isEdit ? { areaId: this.dataForm.areaId } : {}),
        ...(this.isEdit ? { ...original } : {})
      });
      // const areaId = res.data
      const { data } = await queryArea({
        ...(this.isEdit ? { areaId: this.dataForm.areaId } : { areaId: res.data })
      });
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      // 提交成功保存返回ID，再添加列表的编辑功能中有用
      this.$emit('ok', {
        ...params,
        ...data,
        ...(this.isEdit ? { areaId: this.dataForm.areaId } : { areaId: res.data }),
        propertyNums: +data.propertyNum + +data.monthNum + ''
      });
      this.form.resetFields();
    } catch (e) {
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
      console.log(e);
    } finally {
      this.spining = false;
    }
  }
  /**
   * form布局
   */
  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 }
    }
  };
  tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 18,
        offset: 6
      }
    }
  };
  centerFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 14,
        offset: 10
      }
    }
  };
}
